// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"49c56348","504":"9211159d","590":"3d44770b","785":"38c36f02"}[chunkId] + ".chunk.css";
};